const INDICADORES = {
  IPCA: {
    indicador_id: 'IPCA',
    indicador: 'Índice Nacional de Preços ao Consumidor Amplo',
    indicador_sigla: 'IPCA',
    indicador_tipo_id: 'C'
  },
  IGPM: {
    indicador_id: 'IGPM',
    indicador: 'Índice Geral de Preços do Mercado',
    indicador_sigla: 'IGPM',
    indicador_tipo_id: 'C'
  },
  DI: { indicador_id: 'DI', indicador: 'Taxa DI', indicador_sigla: 'DI', indicador_tipo_id: 'J' },
  POUP: {
    indicador_id: 'POUP',
    indicador: 'Poupança',
    indicador_tipo_id: 'J',
    indicador_sigla: 'Poupança'
  },
  SELIC: {
    indicador_id: 'SELIC',
    indicador: 'Taxa Selic',
    indicador_sigla: 'SELIC',
    indicador_tipo_id: 'J'
  },
  IBOV: {
    indicador_id: 'IBOV',
    indicador: 'Índice Bovespa',
    indicador_sigla: 'IBOV',
    indicador_tipo_id: 'I'
  },
  IDIV: {
    indicador_id: 'IDIV',
    indicador: 'Índice Dividendos',
    indicador_tipo_id: 'I',
    indicador_sigla: 'IDIV'
  },
  IFIX: {
    indicador_id: 'IFIX',
    indicador: 'Índice Fundos Investimento Imobiliários B3',
    indicador_tipo_id: 'I',
    indicador_sigla: 'IFIX'
  },
  IMAB: {
    indicador_id: 'IMAB',
    indicador: 'Índice de Mercado ANBIMA indexado ao IPCA',
    indicador_tipo_id: 'I',
    indicador_sigla: 'IMA-B'
  },
  USD: {
    indicador_id: 'USD',
    indicador: 'Dólar',
    indicador_tipo_id: 'M',
    indicador_sigla: 'Dólar'
  },
  ANBID: {
    indicador_id: 'ANBID',
    indicador: 'Taxa ANBID',
    indicador_tipo_id: 'J',
    indicador_sigla: 'ANBID'
  },
  EUR: {
    indicador_id: 'EUR',
    indicador: 'Euro',
    indicador_tipo_id: 'M',
    indicador_sigla: 'Euro'
  },
  IBXL: {
    indicador_id: 'IBXL',
    indicador: 'Índice Brasil 50',
    indicador_tipo_id: 'I',
    indicador_sigla: 'IBrX 50'
  },
  IBXX: {
    indicador_id: 'IBXX',
    indicador: 'Índice Brasil',
    indicador_tipo_id: 'I',
    indicador_sigla: 'IBrX'
  },
  IEEX: {
    indicador_id: 'IEEX',
    indicador: 'Índice de Energia Elétrica',
    indicador_tipo_id: 'I',
    indicador_sigla: 'IEE'
  },
  IGPDI: {
    indicador_id: 'IGPDI',
    indicador: 'Índice Geral de Preços - Disponibilidade Interna',
    indicador_tipo_id: 'C',
    indicador_sigla: 'IGP-DI'
  },
  IMAB5: {
    indicador_id: 'IMAB5',
    indicador: 'Índice de Mercado ANBIMA indexado ao IPCA com duração de até 5 anos',
    indicador_tipo_id: 'I',
    indicador_sigla: 'IMA-B 5'
  },
  IMAB5M: {
    indicador_id: 'IMAB5M',
    indicador: 'Índice de Mercado ANBIMA indexado ao IPCA com duração acima de 5 anos',
    indicador_tipo_id: 'I',
    indicador_sigla: 'IMA-B 5+'
  },
  IMAC: {
    indicador_id: 'IMAC',
    indicador: 'Índice de Mercado ANBIMA indexado ao IGP-M',
    indicador_tipo_id: 'I',
    indicador_sigla: 'IMA-C'
  },
  IMAG: {
    indicador_id: 'IMAG',
    indicador: 'Índice de Mercado ANBIMA Geral',
    indicador_tipo_id: 'I',
    indicador_sigla: 'IMA-Geral'
  },
  IPC: {
    indicador_id: 'IPC',
    indicador: 'Índice de Preços ao Consumidor',
    indicador_tipo_id: 'C',
    indicador_sigla: 'IPC'
  },
  IRF: {
    indicador_id: 'IRF',
    indicador: 'Índice de Renda Fixa do Mercado',
    indicador_tipo_id: 'I',
    indicador_sigla: 'IRF-M'
  },
  PIBB: {
    indicador_id: 'PIBB',
    indicador: 'Papéis de Índice Brasil Bovespa',
    indicador_tipo_id: 'I',
    indicador_sigla: 'PIBB'
  },
  PRE: {
    indicador_id: 'PRE',
    indicador: 'Taxa Prefixada',
    indicador_tipo_id: 'J',
    indicador_sigla: 'Pré'
  },
  TBF: {
    indicador_id: 'TBF',
    indicador: 'Taxa Básica Financeira',
    indicador_tipo_id: 'J',
    indicador_sigla: 'TBF'
  },
  TJLP: {
    indicador_id: 'TJLP',
    indicador: 'Taxa de Juros de Longo Prazo',
    indicador_tipo_id: 'J',
    indicador_sigla: 'TJLP'
  },
  TR: {
    indicador_id: 'TR',
    indicador: 'Taxa Referencial',
    indicador_tipo_id: 'J',
    indicador_sigla: 'TR'
  },
  XAU: {
    indicador_id: 'XAU',
    indicador: 'Ouro',
    indicador_tipo_id: 'M',
    indicador_sigla: 'Ouro'
  }
};

export default INDICADORES;
